import type { SheetColumn, SheetState } from "~/features/dataImportProjects/hooks";
import type { DataSourceFormData, PropertySchemaAssociationFormData } from "~/features/dataImportProjects/types";

export const SheetMapper = {
  toDataSourceInput: (projectId: string, name: string, referenceIds: string[], sheet: SheetState) => {
    const dataSourceName = `${name} - ${sheet.name}`;

    return {
      name: dataSourceName,
      referenceIds,
      importProjectId: projectId,
      gSheetsConfig: { sheetName: sheet.name },
      dataSourcePropertySchemas: sheet.columns.map((column, index) => SheetMapper.column.toFormData(column, index)),
    };
  },

  toDataSourceInputs: (projectId: string, { name, references, sheets }: DataSourceFormData) => {
    const referenceIds = references.map((ref) => ref.id);
    return sheets.map((sheet) => SheetMapper.toDataSourceInput(projectId, name, referenceIds, sheet));
  },

  column: {
    toFormData: (column: SheetColumn, index: number): PropertySchemaAssociationFormData => ({
      name: column.columnLabel,
      description: column.property.description || undefined,
      position: index + 1,
      required: column.property.required,
      unique: column.property.unique,
      propertyAttributeTypeId: column.property.propertyAttributeTypeId || null,
      propertySchema: {
        propertyTypeId: column.property.propertySchema.propertyTypeId,
        selectOptions: column.property.propertySchema.selectOptions,
        urlAllowList: column.property.propertySchema.urlAllowList,
      },
    }),
  },
};
